import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { NewFolderPageComponent } from '../pages/new.component';
import { NewFolderComponent } from '../components/new.component';

import { InspectionFolderEditPageComponent } from '../pages/edit.component';
import { InspectionFolderEditComponent } from '../components/edit.component';

import { routedComponents, FolderRoutingModule } from './folder.routing';
import { SharedModule } from '../../shared.module';

@NgModule({
  imports: [CommonModule, SharedModule, FolderRoutingModule, FormsModule, ReactiveFormsModule],
  declarations: [
    routedComponents,
    NewFolderPageComponent,
    NewFolderComponent,
    InspectionFolderEditPageComponent,
    InspectionFolderEditComponent
  ],
  exports: []
})
export class FolderModule {}
